import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { LineageRootList } from '@/components/knowledge/LineageRootList';
import { LineageChainDetail } from '@/components/knowledge/LineageChainDetail';
import { useLineageStore } from '@/stores/lineage';

export function LineagePage() {
  const { rootId } = useParams<{ rootId?: string }>();
  const { fetchChain, selectRoot } = useLineageStore();

  useEffect(() => {
    if (rootId) {
      fetchChain(rootId);
    } else {
      selectRoot(null);
    }
  }, [rootId, fetchChain, selectRoot]);

  return (
    <div className="flex flex-col h-full bg-slate-50">
      <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200 bg-white">
        <div>
          <h1 className="text-xl font-semibold text-navy-900">Research Lineage</h1>
          <p className="text-sm text-slate-500 mt-0.5">
            Recursive research chains — each root spawns follow-up tasks via the
            autonomous fleet
          </p>
        </div>
      </div>

      <div className="flex flex-1 min-h-0">
        <div className="w-80 flex-shrink-0">
          <LineageRootList />
        </div>
        <div className="flex-1 min-w-0 bg-white">
          <LineageChainDetail />
        </div>
      </div>
    </div>
  );
}
